import { render, staticRenderFns } from "./ColorTintsSelect.vue?vue&type=template&id=0f88a744&scoped=true&"
import script from "./ColorTintsSelect.vue?vue&type=script&lang=js&"
export * from "./ColorTintsSelect.vue?vue&type=script&lang=js&"
import style0 from "./ColorTintsSelect.vue?vue&type=style&index=0&id=0f88a744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88a744",
  null
  
)

export default component.exports